// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-expansion-panel-header {
  padding: 24px !important;
}

.card {
  margin-bottom: 16px;
}

.note-field {
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
}
.note-field .note-field-textarea {
  width: 100%;
  min-height: 95px;
}

.previous-rating-row {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  padding: 10px 15px;
  margin-bottom: 16px;
}
.previous-rating-row .previous-rating-label {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.54);
}
.previous-rating-row .previous-rating-badge {
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  background: rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 2px 10px;
}

.hint {
  text-align: right;
  display: block;
}

.color-grayblue {
  color: #324758;
}

.category-header {
  margin: 0px;
  font-weight: bold;
}

.category-instructions {
  min-width: 40%;
  padding: 15px 20px 15px 5px;
}

.category-activities {
  width: -moz-fit-content;
  width: fit-content;
  padding-right: 10px;
  margin: 15px 0px 0px 12px;
}
.category-activities .category-activities-header {
  font-size: 14px;
  font-weight: bold;
  margin: 10px;
}

.question-description {
  font-size: 14px;
  margin-top: 14px;
  margin-bottom: 14px;
}

.row {
  display: flex;
}

.column {
  display: flex;
  flex-direction: column;
  flex: 1 100%;
}

.checkbox-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.rating-card {
  padding: 15px;
}
.rating-card .rating-section-name {
  width: 30%;
  align-content: center;
}
.rating-card .rating-option {
  margin: 0 1rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.rating-card .rating-description {
  min-height: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
}
.rating-card .rating-description .rating-heading {
  font-size: 15px;
  font-weight: bold;
  text-align: left;
}
.rating-card .rating-description .rating-text {
  font-size: 14px;
  line-height: normal;
  text-align: justify;
}

@media (max-width: 768px) {
  .rating-card .row {
    flex-direction: column;
    padding: 0 2vw;
  }
  .rating-card .rating-option {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0;
  }
  .rating-card .rating-section-name {
    text-align: center;
    width: 100%;
    margin-top: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/intern/obs-assessment/obs-domains/obs-domains.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,wBAAA;EAAA,mBAAA;AACF;AACE;EACE,WAAA;EACA,gBAAA;AACJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAHF;AAKE;EACE,eAAA;EACA,0BAAA;AAHJ;AAME;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,mBAAA;EACA,iBAAA;AAJJ;;AAQA;EACE,iBAAA;EACA,cAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACI,WAAA;EACA,iBAAA;AALJ;;AAQA;EACE,cAAA;EACA,2BAAA;AALF;;AAQA;EACE,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,yBAAA;AALF;AAOE;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AALJ;;AASA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AANJ;;AASA;EACI,aAAA;AANJ;;AASA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AANJ;;AASA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AANF;;AASA;EACI,aAAA;AANJ;AAQI;EACI,UAAA;EACA,qBAAA;AANR;AASI;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAPN;AAUI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,OAAA;AARN;AAUM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AARR;AAWM;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;AATR;;AAcA;EACE;IACE,sBAAA;IACA,cAAA;EAXF;EAcA;IACE,WAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;IACA,cAAA;EAZF;EAgBA;IACE,kBAAA;IACA,WAAA;IACA,eAAA;EAdF;AACF","sourcesContent":["::ng-deep .mat-expansion-panel-header {\n  padding: 24px !important;\n}\n\n.card {\n  margin-bottom: 16px;\n}\n\n.note-field {\n  width: 100%;\n  height: fit-content;\n\n  .note-field-textarea{\n    width: 100%;\n    min-height: 95px;\n  }\n}\n\n\n\n\n.previous-rating-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 4px;\n  padding: 10px 15px;\n  margin-bottom: 16px;\n\n  .previous-rating-label {\n    font-size: 13px;\n    color: rgba(0, 0, 0, 0.54);\n  }\n\n  .previous-rating-badge {\n    font-size: 13px;\n    font-weight: 500;\n    color: rgba(0, 0, 0, 0.60);\n    background: rgba(0, 0, 0, 0.08);\n    border-radius: 12px;\n    padding: 2px 10px;\n  }\n}\n\n.hint {\n  text-align: right;\n  display: block;\n}\n\n.color-grayblue {\n  color: #324758;\n}\n\n.category-header {\n    margin: 0px;\n    font-weight: bold;\n}\n\n.category-instructions {\n  min-width: 40%;\n  padding: 15px 20px 15px 5px;\n}\n\n.category-activities{\n  width: fit-content;\n  padding-right: 10px;\n  margin: 15px 0px 0px 12px;\n\n  .category-activities-header {\n    font-size: 14px;\n    font-weight: bold;\n    margin: 10px;\n  }\n}\n\n.question-description {\n    font-size: 14px;\n    margin-top: 14px;\n    margin-bottom: 14px;\n}\n\n.row {\n    display: flex;\n}\n\n.column {\n    display: flex;\n    flex-direction: column;\n    flex: 1 100%;\n}\n\n.checkbox-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.rating-card {\n    padding: 15px;\n\n    .rating-section-name {\n        width: 30%;\n        align-content: center;\n    }\n\n    .rating-option {\n      margin: 0 1rem;\n      text-align: center;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: flex-end;\n      cursor: pointer;\n      user-select: none;\n    }\n\n    .rating-description {\n      min-height: 40px;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      flex: 1;\n\n      .rating-heading {\n        font-size: 15px;\n        font-weight: bold;\n        text-align: left;\n      }\n\n      .rating-text {\n        font-size: 14px;\n        line-height: normal;\n        text-align: justify;\n      }\n    }\n}\n\n@media (max-width: 768px) {\n  .rating-card .row {\n    flex-direction: column;\n    padding: 0 2vw;\n  }\n\n  .rating-card .rating-option {\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin: 1rem 0;\n\n  }\n\n  .rating-card .rating-section-name {\n    text-align: center;\n    width: 100%;\n    margin-top: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
